import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Checkup from "../../components/checkup"
import { Link } from "gatsby"
import OtherCaseStudy from "../../components/other-case"

import gogleads from "../../assets/img/gogleads.png"
import criteo from "../../assets/img/criteo.jpg"
import fbook from "../../assets/img/fbook.png"
import tiktok from "../../assets/img/tiktok-new.png"
import twitter from "../../assets/img/twitter-new.png"
import fullamobil from "../../assets/img/fulla-mobil.png"
import webtrafik from "../../assets/img/web-trafik.png"
import realtime from "../../assets/img/realtime2.png"

import melisa from "../../assets/img/teams/18.jpg"
import serife from "../../assets/img/teams/20.jpg"
import duygu from "../../assets/img/teams/41.jpg"




const ReferancesDetail = () => (
    <Layout>
        <SEO title="Fullamoda Success Story" />
        <div className="referances-detail py60 container" style={{ maxWidth: 950}}>
            <div className="col-md-12 detail-left" >
                <b>SUCCESS STORY</b>
                <h1>Fullamoda</h1>
                <p>Fulla Moda, a brand that keeps up with current fashion trends beyond conventional patterns, brings trendy products in women's, men's and children's clothing to consumers in Turkey through 70+ physical stores and an e-commerce platform. The rich product range on the Fullamoda online shopping site also wins the hearts of users.</p>
            </div>
            <div className="col-md-6 detail-left">
                <div className="provided">
                    <h3>Services Provided</h3>
                    <div className="provided-box">
                        <div className="box">
                            <Link to="/digital-ads/"></Link>
                            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 76 76">
                                <g id="Icons-_-Shopping-_-Cart_1" data-name="Icons-/-Shopping-/-Cart#1" transform="translate(0.452 0.373)">
                                    <rect id="bound" width="76" height="76" transform="translate(-0.452 -0.373)" fill="none" />
                                    <path id="Combined-Shape" d="M52.453,31.233l-2.2,13.227-.008.046a3.161,3.161,0,0,1-3.675,2.544L10.63,40.517a3.161,3.161,0,0,1-2.474-2.241L2.389,18.088a3.161,3.161,0,0,1,3.039-4.029H48.813l1.938-8.306a3.729,3.729,0,0,1,3.632-2.882h6.527a3.729,3.729,0,1,1,0,7.459H57.342Z" transform="translate(4.899 6.203)" fillRule="evenodd" opacity="0.3" />
                                    <path id="Combined-Shape-2" data-name="Combined-Shape" d="M9.741,27.482a4.741,4.741,0,1,1,4.741-4.741A4.741,4.741,0,0,1,9.741,27.482Zm28.447,0a4.741,4.741,0,1,1,4.741-4.741A4.741,4.741,0,0,1,38.188,27.482Z" transform="translate(10.804 38.894)" fillRule="evenodd" />
                                </g>
                            </svg>
                            Digital Ads
                        </div>
                        <div className="box">
                            <Link to="/digital-consulting/"></Link>
                            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 76 76">
                                <g id="Icons-_-Design-_-Sketch" data-name="Icons-/-Design-/-Sketch" transform="translate(0.015 -0.307)">
                                    <rect id="bound" width="76" height="76" transform="translate(-0.015 0.307)" fill="none" />
                                    <path id="Path-48" d="M13.728,3H58.276L71,18.91H1Z" transform="translate(2.182 6.546)" fillRule="evenodd" opacity="0.3" />
                                    <path id="Path-48-Copy" d="M71,8,36,46.184,1,8Z" transform="translate(2.182 17.456)" fillRule="evenodd" />
                                </g>
                            </svg>
                            Digital Consulting
                        </div>
                    </div>
                </div>

            </div>
            <div className="col-md-6 project-details">
                    <h3>Impressum</h3>
                    <div className="project-details_list">
                        <ul>
                            <li>Brand Strategist:</li>
                            <li>Brand Manager:</li>
                            <li>Digital Ads Specialist:</li>
                        </ul>
                        <ul>
                            <li><img src={melisa}  alt="Melisa Akınsal"/>Melisa Akınsal</li>
                            <li><img src={duygu} alt="Duygu Ekim Serteser" />Duygu Serteser</li>
                            <li><img src={serife} alt="Şerife Aytekin" />Şerife Aytekin</li>
                        </ul>
                    </div>

            </div>
        </div>
        <div className="container">

            <div className="content-section content row" >
                <div className="col-md-6">
                    <img  src={fullamobil} alt="Fullamoda website displayed on two laptop screens" />
                </div>
                <div className="col-md-6">
                    <p className="small" style={{ maxWidth: 480, color:"#ea4f6a", textAlign:"left" }} >Success Story</p>
                    <h3 style={{ maxWidth: 480, fontSize: 25, textAlign:"left" }}><b>Fullamoda X Flatart</b></h3>
                    <p style={{ maxWidth: 480, textAlign:"left" }} >Flatart's path crossed with Fullamoda — a brand that always delivers a dynamic shopping experience to its customers through active e-commerce campaigns and website management — for the first time during a Black Friday campaign.</p>
                    <p style={{ maxWidth: 480, textAlign:"left"}}>While the discount campaign aimed to acquire new users, retargeting ad actions were also taken with special discount codes. Aware that we were competing with major players in a challenging sector, we used trending ad models and real-time solutions along with CRO-focused actions to deliver a successful campaign.</p>

                </div>
            </div>
            <div className="text-center">
                <span className="small">Success Story</span>
                <h2 style={{ margin: '7px auto -20px', maxWidth: 900 }}>1 to 5 ROI Gain</h2>
            </div>
            <div className="referances-detail py60" >
                <div className="referances-boxs" >
                    <div className="boxs">
                            <div className="box" style={{ width: 230 }}>
                                <span>+%114.70</span>
                                <p>Increase in E-commerce Conversion Rate</p>
                            </div>
                            <div className="box" style={{ width: 230 }} >
                                <span>+%160.55</span>
                                <p>Increase in Website Sales Volume</p>
                            </div>
                            <div className="box" style={{ width: 230 }} >
                                <span>+%279.20</span>
                                <p>Revenue Increase</p>
                            </div>
                            <div className="box" style={{ width: 230 }}>
                                <span>+%22.27</span>
                                <p>Session Count Increase</p>
                            </div>
                    </div>
                </div>
            </div>

            <div className="text-center">
            <span className="small">Success Story</span>
                <h2 style={{ margin: '7px auto 20px', maxWidth: 900 }}><b>CRO-Supporting Sales Channels</b> </h2>
                <div className="col-md-4">
                    <img style={{ maxHeight: 120}} src={gogleads} alt="Google Ads logo" />
                    <p style={{ fontSize: 25, margin: '10px auto 30px'}}>Google Ads</p>
                </div>
                <div className="col-md-4">
                    <img style={{ maxHeight: 120}} src={criteo} alt="Criteo logo" />
                    <p style={{ fontSize: 25, margin: '10px auto 30px'}}>Criteo</p>
                </div>
                <div className="col-md-4">
                    <img style={{ maxHeight: 120}} src={fbook} alt="Facebook Instagram Ads logo" />
                    <p style={{ fontSize: 25, margin: '10px auto 30px'}}>Facebook&Instagram Ads</p>
                </div>
            </div>

            <div className="text-center">
                <p style={{ fontSize: 18, margin: '30px auto 30px', maxWidth: 800 }}>In ad campaigns that targeted not only sales but also brand awareness, ads were also published on TikTok and Twitter. Together with video broadcasts, <b>1.5M+</b> ad video view actions were achieved.</p>
                <div className="col-md-3"></div>
                <div className="col-md-3">
                    <img style={{ maxHeight: 120}} src={tiktok} alt="TikTok logo" />
                </div>
                <div className="col-md-3">
                    <img style={{ maxHeight: 120}} src={twitter} alt="Twitter logo" />
                </div>
                <div className="col-md-3"></div>
            </div>

        </div>

        <div className="container">
            <div className="text-center">
                <h2 style={{ margin: '70px auto 20px', maxWidth: 900 }}>Campaign Period Website Traffic</h2>
                <img style={{ width: '90%', margin: '0 auto' }} src={webtrafik} alt="Campaign period website traffic chart" />
                <h2 style={{ margin: '20px auto 20px', maxWidth: 900 }}>Digital Consulting &amp; Realtime Action</h2>
                <p style={{ fontSize: 18, margin: '30px auto 30px', maxWidth: 800 }}>Following a major campaign period like Black Friday, we evaluated the increasingly trending "2022 Price Hikes" agenda in the digital space and organized and managed the "These Prices Won't Come Back!" campaign that set us apart from our competitors in the sector.</p>
                <img style={{ width: '70%', margin: '0 auto' }} src={realtime} alt="Realtime action analytics" />
                <p style={{ fontSize: 18, margin: '30px auto 30px', maxWidth: 800 }}>As a result of the CRO-focused actions we took — centered on the products users were searching for on our site and in the digital space — we achieved 2,000+ product sales.</p>

            </div>

        </div>




        <OtherCaseStudy />

        <Checkup />
    </Layout >
)

export default ReferancesDetail
